import React from "react";
import { Route, Routes } from "react-router-dom";
import { Container } from "./Workspace.styled";
import { Breadcrumb } from "./components";
import { useWorkspaceBreadcrumbs } from "./hooks";
import { Main, WorkspaceDetail } from "./pages";

const Workspace = () => {
  const { items: breadcrumbItems, helpers: breadcrumbHelpers } = useWorkspaceBreadcrumbs();

  return (
    <Container>
      {/* <Breadcrumb items={breadcrumbItems} /> */}
      <Routes>
        <Route path=":workspaceId/*" element={<WorkspaceDetail breadcrumbHelpers={breadcrumbHelpers} />} />
        <Route path="/*" element={<Main breadcrumbHelpers={breadcrumbHelpers} />} />
      </Routes>
    </Container>
  );
};

export default Workspace;

